export default __webpack_public_path__ + "images/SciTech_Icon_Black.png";